import React from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStroopwafel, faCoffee } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'


library.add(faStroopwafel, faCoffee, fab)


const SocialIcon = (props) => (

    <a style={props.style} title={props.title} target="_blank" href={props.link}>
    {/*All fontawesome icon names: https://fontawesome.com/icons?d=gallery*/} 
    <FontAwesomeIcon icon={['fab', props.iconName]} size={props.size} aria-hidden="false" aria-label={props.ariaLabel} />
    </a>

)

export default SocialIcon


// WEBPACK FOOTER //
// ./src/components/Social/socialIcon.js